const state = {
    statusLead: false
}

const mutations = {
    SET_STATUS_LEAD(state, statusLead) {
        state.statusLead = statusLead
    }
}

const actions = {
    async insert({
        dispatch,
        commit        
    }, opt) {
        
        await dispatch(
            'caller/fetchData', {
                url: 'api/lead/insert',
                method: 'post',
                dispatcher: 'lead/insert',
                data: opt.data,
                setLoading: opt.setLoading
            }, {
                root: true
            }
            
        ).then((promise) => {
            if (promise !== undefined) {
                commit("SET_STATUS_LEAD", true)
            }
        })
        .catch(() => {})
    }    
}

export default {
    state,
    namespaced: true,
    mutations,
    actions
  };